import API from './axios';

// Job Management API Service
export const jobService = {
  // Get all jobs with pagination and filters
  getAllJobs: async (params = {}) => {
    const { page = 1, limit = 20, status, category, priority, driverId } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(status && { status }),
      ...(category && { category }),
      ...(priority && { priority }),
      ...(driverId && { driverId })
    });

    const response = await API.get(`/admin/jobs?${queryParams}`);
    return response.data;
  },

  // Get job by ID
  getJobById: async (jobId) => {
    const response = await API.get(`/admin/jobs/${jobId}`);
    return response.data;
  },

  // Create new job
  createJob: async (jobData) => {
    const response = await API.post('/admin/jobs', jobData);
    return response.data;
  },

  // Update job
  updateJob: async (jobId, updateData) => {
    const response = await API.put(`/admin/jobs/${jobId}`, updateData);
    return response.data;
  },

  // Delete job
  deleteJob: async (jobId) => {
    const response = await API.delete(`/admin/jobs/${jobId}`);
    return response.data;
  },

  // Assign job to driver
  assignJob: async (jobId, driverId) => {
    const response = await API.post(`/admin/jobs/${jobId}/assign`, { driverId });
    return response.data;
  },

  // Get job performance analytics
  getJobPerformance: async () => {
    const response = await API.get('/admin/jobs/analytics/performance');
    return response.data;
  },

  // Get available drivers for job assignment
  getAvailableDrivers: async () => {
    const response = await API.get('/admin/drivers/available'); // Changed endpoint
    return response.data;
  },

  // Predefined Jobs API methods
  getAllPredefinedJobs: async (page = 1, limit = 20, search = '') => {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append('search', search);
    const response = await API.get(`/admin/predefined-jobs?${params}`);
    return response.data;
  },

  createPredefinedJob: async (jobData) => {
    const response = await API.post('/admin/predefined-jobs', jobData);
    return response.data;
  },

  getPredefinedJobById: async (id) => {
    const response = await API.get(`/admin/predefined-jobs/${id}`);
    return response.data;
  },

  updatePredefinedJob: async (id, jobData) => {
    const response = await API.put(`/admin/predefined-jobs/${id}`, jobData);
    return response.data;
  },

  deletePredefinedJob: async (id) => {
    const response = await API.delete(`/admin/predefined-jobs/${id}`);
    return response.data;
  },

  assignPredefinedJob: async (id, driverId) => {
    const response = await API.post(`/admin/predefined-jobs/${id}/assign`, { driverId });
    return response.data;
  },

  // Scheduled Jobs Management
  getAllScheduledJobs: async (params = {}) => {
    const { page = 1, limit = 20, status, driverId, startDate, endDate } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(status && { status }),
      ...(driverId && { driverId }),
      ...(startDate && { startDate }),
      ...(endDate && { endDate })
    });

    const response = await API.get(`/admin/scheduled-jobs?${queryParams}`);
    return response.data;
  },

  createScheduledJob: async (jobData) => {
    const response = await API.post('/admin/scheduled-jobs', jobData);
    return response.data;
  },

  getScheduledJobById: async (jobId) => {
    const response = await API.get(`/admin/scheduled-jobs/${jobId}`);
    return response.data;
  },

  updateScheduledJob: async (jobId, updateData) => {
    const response = await API.put(`/admin/scheduled-jobs/${jobId}`, updateData);
    return response.data;
  },

  deleteScheduledJob: async (jobId) => {
    const response = await API.delete(`/admin/scheduled-jobs/${jobId}`);
    return response.data;
  },

  releaseScheduledJob: async (jobId) => {
    const response = await API.post(`/admin/scheduled-jobs/${jobId}/release`);
    return response.data;
  }
};

export default jobService; 